<template>
  <div class="">
    <span class="text-warning Number ml-3 p-2 Rounded">{{ rows.length }}</span>
    <span class="">قرارداد مشتریان در انتظار تایید شما برای ثبت دائم قرارداد</span>
    <span class=""><i class="fas fa-eye font-weight-bold hover-danger float-left my-2 Pointer" @click="OnCartableContract()" title="مشاهده همه"></i></span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rows: [],
    }
  },
  methods: {
    GetRow() {
      let DataAxios_Get = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Contract/CartableContract',
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxios_Get).then((data) => {
        this.rows = data
      })
    },
    OnCartableContract() {
      this.$router.push({ name: 'CartableContract' })
    },
  },
  mounted() {},
  created() {
    this.GetRow()
  },
}
</script>
<style scoped>
.Number {
  font-size: 18px !important;
}
</style>
